import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Lenis from "lenis";
import { setLenis } from "@/lib/scroll";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CallFab from "@/components/site/CallFab";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, autoRaf: true });
    setLenis(lenis);
    return () => { lenis.destroy(); setLenis(null); };
  }, []);
  return null;
};

const ScrollTopOnRoute = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollTopOnRoute />
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:bg-white focus:px-4 focus:py-2">Saltar al contenido</a>
        <Header />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/aviso-legal" element={<Legal kind="aviso-legal" />} />
            <Route path="/privacidad" element={<Legal kind="privacidad" />} />
            <Route path="/cookies" element={<Legal kind="cookies" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CallFab />
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
